export default "__VITE_ASSET__BKxZNj3l__"